import { Box, Pressable, Text, VStack } from "native-base";
import React from "react";
import PropTypes from "prop-types";
import Modal from "../modal";
import colors from "../../constants/colors";

function NoResultsModal(props) {
  const { isOpen, onRequestClose } = props;

  if (!isOpen) {
    return null;
  }

  return (
    <Modal maxWidth={500} isOpen onRequestClose={onRequestClose}>
      <VStack paddingX={10} paddingY={8} space={5} alignItems="center">
        <Text bold color={colors.secondary} textAlign="center" fontSize="lg">
          La unidad no tiene acceso a la ubicación indicada (lagos, rios,
          cascadas, vialidad), por favor verifica e ingresa nuevamente tu
          destino.
        </Text>
        <Pressable onPress={onRequestClose}>
          <Box
            backgroundColor={colors.primary}
            paddingY={3}
            paddingX={100}
            borderRadius="full">
            <Text color={colors.white}>Cerrar</Text>
          </Box>
        </Pressable>
      </VStack>
    </Modal>
  );
}

NoResultsModal.propTypes = {
  isOpen: PropTypes.bool,
  onRequestClose: PropTypes.func,
};

NoResultsModal.defaultProps = {
  isOpen: false,
};

export default React.memo(NoResultsModal);
